<template>
  <LazyAppHeaderDefault
    v-if="route.meta.header === 'default'"
    ref="header"
    class="h-header-mobile laptop:h-header mx-auto"
  />
  <LazyAppHeaderList
    v-else-if="route.meta.header === 'list'"
    ref="header"
    class="h-header-mobile laptop:h-header z-40 mx-auto"
  />
  <client-only v-if="!header && route.meta.header">
    <header
      class="h-header-mobile laptop:h-header animate-pulse bg-gray-100"
    ></header>
  </client-only>
</template>

<script setup>
const route = useRoute();
const header = useTemplateRef("header");
</script>
